import { Headline } from "@/widget-components/newsquawk-headlines/models/Headline";
import { create } from "zustand";

type HeadlineFormStore = {
  headline: Partial<Headline> | null;
  setHeadline: (headline: Partial<Headline>) => void;
  clearHeadline: () => void;
};

const initialState = {
  headline: null,
};

export const useHeadlineFormStore = create<HeadlineFormStore>((set) => ({
  ...initialState,

  setHeadline: (headline: Partial<Headline>) =>
    set({
      headline,
    }),

  clearHeadline: () => set({ ...initialState }),
}));
